/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export var SortOrder;
(function (SortOrder) {
  SortOrder["Asc"] = "asc";
  SortOrder["Desc"] = "desc";
})(SortOrder || (SortOrder = {}));
export var SortField;
(function (SortField) {
  SortField["Id"] = "id";
  SortField["CreatedAt"] = "createdAt";
  SortField["UpdatedAt"] = "updatedAt";
})(SortField || (SortField = {}));
export var LangCode;
(function (LangCode) {
  LangCode["RU"] = "RU";
  LangCode["EN"] = "EN";
})(LangCode || (LangCode = {}));
export var NewsStatus;
(function (NewsStatus) {
  NewsStatus["DRAFT"] = "DRAFT";
  NewsStatus["PUBLISHED"] = "PUBLISHED";
  NewsStatus["HIDDEN"] = "HIDDEN";
  NewsStatus["DELETED"] = "DELETED";
})(NewsStatus || (NewsStatus = {}));
export var UploadFileType;
(function (UploadFileType) {
  UploadFileType["IMAGE"] = "IMAGE";
  UploadFileType["VIDEO"] = "VIDEO";
  UploadFileType["CATALOG"] = "CATALOG";
  UploadFileType["PDF"] = "PDF";
})(UploadFileType || (UploadFileType = {}));
export var MaterialSortField;
(function (MaterialSortField) {
  MaterialSortField["Id"] = "id";
  MaterialSortField["CreatedAt"] = "createdAt";
  MaterialSortField["UpdatedAt"] = "updatedAt";
  MaterialSortField["PublishedAt"] = "publishedAt";
})(MaterialSortField || (MaterialSortField = {}));
export var MaterialStatus;
(function (MaterialStatus) {
  MaterialStatus["DRAFT"] = "DRAFT";
  MaterialStatus["PUBLISHED"] = "PUBLISHED";
  MaterialStatus["HIDDEN"] = "HIDDEN";
  MaterialStatus["DELETED"] = "DELETED";
})(MaterialStatus || (MaterialStatus = {}));
export var WorkFormat;
(function (WorkFormat) {
  WorkFormat["REMOTE"] = "REMOTE";
  WorkFormat["ONSITE"] = "ONSITE";
  WorkFormat["UNLIMITED"] = "UNLIMITED";
})(WorkFormat || (WorkFormat = {}));
export var UserRole;
(function (UserRole) {
  UserRole["OWNER"] = "OWNER";
  UserRole["ADMIN"] = "ADMIN";
  UserRole["EMPLOYEE"] = "EMPLOYEE";
})(UserRole || (UserRole = {}));
export var EducationLevel;
(function (EducationLevel) {
  EducationLevel["BACHELOR"] = "BACHELOR";
  EducationLevel["MASTER"] = "MASTER";
  EducationLevel["DOCTORATE"] = "DOCTORATE";
  EducationLevel["POSTGRADUATE"] = "POSTGRADUATE";
})(EducationLevel || (EducationLevel = {}));
export var AcademySortField;
(function (AcademySortField) {
  AcademySortField["Id"] = "id";
  AcademySortField["CreatedAt"] = "createdAt";
  AcademySortField["UpdatedAt"] = "updatedAt";
  AcademySortField["PublishedAt"] = "publishedAt";
})(AcademySortField || (AcademySortField = {}));
export var AcademyType;
(function (AcademyType) {
  AcademyType["COURSE"] = "COURSE";
  AcademyType["GUIDE"] = "GUIDE";
})(AcademyType || (AcademyType = {}));
export var AcademyMaterialType;
(function (AcademyMaterialType) {
  AcademyMaterialType["LINK"] = "LINK";
  AcademyMaterialType["FILE"] = "FILE";
})(AcademyMaterialType || (AcademyMaterialType = {}));
export var AcademyFileType;
(function (AcademyFileType) {
  AcademyFileType["LOGO"] = "LOGO";
  AcademyFileType["FILE"] = "FILE";
})(AcademyFileType || (AcademyFileType = {}));
import axios from "axios";
export var ContentType;
(function (ContentType) {
  ContentType["Json"] = "application/json";
  ContentType["FormData"] = "multipart/form-data";
  ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
  ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
  instance;
  securityData = null;
  securityWorker;
  secure;
  format;
  constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }
  setSecurityData = (data) => {
    this.securityData = data;
  };
  mergeRequestParams(params1, params2) {
    const method = params1.method || (params2 && params2.method);
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }
  stringifyFormItem(formItem) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }
  createFormData(input) {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent = property instanceof Array ? property : [property];
      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }
      return formData;
    }, new FormData());
  }
  request = async ({ secure, path, type, query, format, body, ...params }) => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;
    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body);
    }
    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }
    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}
/**
 * @title Nalogika Api
 * @version 1.0
 * @contact
 *
 * API Doc
 */
export class ApiClient extends HttpClient {
  /**
   * No description
   *
   * @name AppControllerGetHello
   * @request GET:/
   * @response `200` `void`
   */
  appControllerGetHello = (params = {}) =>
    this.request({
      path: `/`,
      method: "GET",
      ...params,
    });
  file = {
    /**
     * No description
     *
     * @tags files
     * @name FileControllerUploadFile
     * @request POST:/file
     * @response `201` `void`
     */
    fileControllerUploadFile: (data, params = {}) =>
      this.request({
        path: `/file`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags files
     * @name FileControllerUploadVideoFile
     * @request POST:/file/video
     * @response `201` `void`
     */
    fileControllerUploadVideoFile: (data, params = {}) =>
      this.request({
        path: `/file/video`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags files
     * @name FileControllerUploadImageForEditor
     * @request POST:/file/tinymce-upload
     * @response `201` `void`
     */
    fileControllerUploadImageForEditor: (params = {}) =>
      this.request({
        path: `/file/tinymce-upload`,
        method: "POST",
        ...params,
      }),
  };
  catalogs = {
    /**
     * No description
     *
     * @tags catalogs
     * @name CatalogsControllerGetCatalogs
     * @request GET:/catalogs
     * @response `200` `void`
     */
    catalogsControllerGetCatalogs: (query, params = {}) =>
      this.request({
        path: `/catalogs`,
        method: "GET",
        query: query,
        ...params,
      }),
    /**
     * No description
     *
     * @tags catalogs
     * @name CatalogsControllerDownloadFile
     * @request GET:/catalogs/catalog/{fileId}/download/{filename}
     * @response `200` `void`
     */
    catalogsControllerDownloadFile: (fileId, filename, params = {}) =>
      this.request({
        path: `/catalogs/catalog/${fileId}/download/${filename}`,
        method: "GET",
        ...params,
      }),
  };
  dashboard = {
    /**
     * No description
     *
     * @tags admin-catalogs
     * @name AdminCatalogsControllerCreateCatalog
     * @request POST:/dashboard/catalogs
     * @secure
     * @response `201` `void`
     */
    adminCatalogsControllerCreateCatalog: (data, params = {}) =>
      this.request({
        path: `/dashboard/catalogs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-catalogs
     * @name AdminCatalogsControllerUploadFile
     * @request POST:/dashboard/catalogs/{id}/upload-file
     * @secure
     * @response `201` `void`
     */
    adminCatalogsControllerUploadFile: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/catalogs/${id}/upload-file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-catalogs
     * @name AdminCatalogsControllerUploadPreview
     * @request POST:/dashboard/catalogs/{id}/upload-preview
     * @secure
     * @response `201` `void`
     */
    adminCatalogsControllerUploadPreview: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/catalogs/${id}/upload-preview`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-catalogs
     * @name AdminCatalogsControllerUpdateCatalog
     * @request PATCH:/dashboard/catalogs/{id}
     * @secure
     * @response `200` `void`
     */
    adminCatalogsControllerUpdateCatalog: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/catalogs/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-catalogs
     * @name AdminCatalogsControllerDeleteFile
     * @request DELETE:/dashboard/catalogs/{id}
     * @secure
     * @response `200` `void`
     */
    adminCatalogsControllerDeleteFile: (id, params = {}) =>
      this.request({
        path: `/dashboard/catalogs/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-catalogs
     * @name AdminCatalogsControllerRemovePreview
     * @request DELETE:/dashboard/catalogs/{id}/preview
     * @secure
     * @response `200` `void`
     */
    adminCatalogsControllerRemovePreview: (id, query, params = {}) =>
      this.request({
        path: `/dashboard/catalogs/${id}/preview`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/Tags
     * @name AdminTagsControllerCreate
     * @request POST:/dashboard/tags
     * @secure
     * @response `200` `TagEntity`
     */
    adminTagsControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/Tags
     * @name AdminTagsControllerFindMany
     * @request GET:/dashboard/tags
     * @secure
     * @response `200` `TagsResponse`
     */
    adminTagsControllerFindMany: (query, params = {}) =>
      this.request({
        path: `/dashboard/tags`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/Tags
     * @name AdminTagsControllerFindOne
     * @request GET:/dashboard/tags/{id}
     * @secure
     * @response `200` `TagEntity`
     */
    adminTagsControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/dashboard/tags/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/Tags
     * @name AdminTagsControllerUpdate
     * @request PATCH:/dashboard/tags/{id}
     * @secure
     * @response `200` `TagEntity`
     */
    adminTagsControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/tags/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/Tags
     * @name AdminTagsControllerRemove
     * @request DELETE:/dashboard/tags/{id}
     * @secure
     * @response `200` `TagEntity`
     */
    adminTagsControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/tags/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-news
     * @name AdminNewsControllerCreate
     * @request POST:/dashboard/news
     * @secure
     * @response `200` `NewsEntity`
     */
    adminNewsControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/news`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-news
     * @name AdminNewsControllerFindAll
     * @request GET:/dashboard/news
     * @secure
     * @response `200` `NewsResponse`
     */
    adminNewsControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/dashboard/news`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-news
     * @name AdminNewsControllerFindDraft
     * @request GET:/dashboard/news/draft
     * @secure
     * @response `200` `NewsEntity`
     */
    adminNewsControllerFindDraft: (params = {}) =>
      this.request({
        path: `/dashboard/news/draft`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-news
     * @name AdminNewsControllerUploadFile
     * @request POST:/dashboard/news/{id}/upload-file
     * @secure
     * @response `201` `void`
     */
    adminNewsControllerUploadFile: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/news/${id}/upload-file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-news
     * @name AdminNewsControllerUpdate
     * @request PATCH:/dashboard/news/{id}
     * @secure
     * @response `200` `NewsEntity`
     */
    adminNewsControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/news/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-news
     * @name AdminNewsControllerRemove
     * @request DELETE:/dashboard/news/{id}
     * @secure
     * @response `200` `NewsEntity`
     */
    adminNewsControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/news/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-news
     * @name AdminNewsControllerRemovePreview
     * @request DELETE:/dashboard/news/{id}/preview
     * @secure
     * @response `200` `NewsEntity`
     */
    adminNewsControllerRemovePreview: (id, query, params = {}) =>
      this.request({
        path: `/dashboard/news/${id}/preview`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-news
     * @name AdminNewsControllerRemoveImageFromGallery
     * @request DELETE:/dashboard/news/{id}/gallery/{fileId}
     * @secure
     * @response `200` `NewsEntity`
     */
    adminNewsControllerRemoveImageFromGallery: (id, fileId, query, params = {}) =>
      this.request({
        path: `/dashboard/news/${id}/gallery/${fileId}`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/cases
     * @name AdminCasesControllerCreate
     * @request POST:/dashboard/cases
     * @secure
     * @response `200` `CaseEntity`
     */
    adminCasesControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/cases`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/cases
     * @name AdminCasesControllerFindAll
     * @request GET:/dashboard/cases
     * @secure
     * @response `200` `CasesResponse`
     */
    adminCasesControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/dashboard/cases`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/cases
     * @name AdminCasesControllerUploadFile
     * @request POST:/dashboard/cases/{id}/upload-file
     * @secure
     * @response `201` `void`
     */
    adminCasesControllerUploadFile: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/cases/${id}/upload-file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/cases
     * @name AdminCasesControllerFindOne
     * @request GET:/dashboard/cases/{id}
     * @secure
     * @response `200` `CaseEntity`
     */
    adminCasesControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/dashboard/cases/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/cases
     * @name AdminCasesControllerUpdate
     * @request PATCH:/dashboard/cases/{id}
     * @secure
     * @response `200` `CaseEntity`
     */
    adminCasesControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/cases/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/cases
     * @name AdminCasesControllerRemove
     * @request DELETE:/dashboard/cases/{id}
     * @secure
     * @response `200` `CaseEntity`
     */
    adminCasesControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/cases/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/cases
     * @name AdminCasesControllerFindDraft
     * @request GET:/dashboard/cases/draft
     * @secure
     * @response `200` `CasesResponse`
     */
    adminCasesControllerFindDraft: (params = {}) =>
      this.request({
        path: `/dashboard/cases/draft`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerCreate
     * @request POST:/dashboard/materials
     * @secure
     * @response `200` `MaterialEntity`
     */
    adminMaterialsControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/materials`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerFindAll
     * @request GET:/dashboard/materials
     * @secure
     * @response `200` `MaterialResponse`
     */
    adminMaterialsControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/dashboard/materials`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerUploadFile
     * @request POST:/dashboard/materials/{id}/upload-photo
     * @secure
     * @response `201` `void`
     */
    adminMaterialsControllerUploadFile: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/materials/${id}/upload-photo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerUploadPdf
     * @request POST:/dashboard/materials/{id}/upload-document
     * @secure
     * @response `201` `void`
     */
    adminMaterialsControllerUploadPdf: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/materials/${id}/upload-document`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerUploadVideoFile
     * @request POST:/dashboard/materials/{id}/upload-video
     * @secure
     * @response `201` `void`
     */
    adminMaterialsControllerUploadVideoFile: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/materials/${id}/upload-video`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerFindOne
     * @request GET:/dashboard/materials/{id}
     * @secure
     * @response `200` `MaterialResponse`
     */
    adminMaterialsControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/dashboard/materials/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerUpdate
     * @request PATCH:/dashboard/materials/{id}
     * @secure
     * @response `200` `MaterialEntity`
     */
    adminMaterialsControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/materials/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerRemove
     * @request DELETE:/dashboard/materials/{id}
     * @secure
     * @response `200` `MaterialEntity`
     */
    adminMaterialsControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/materials/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerRemoveFile
     * @request DELETE:/dashboard/materials/{id}/file
     * @secure
     * @response `200` `MaterialEntity`
     */
    adminMaterialsControllerRemoveFile: (id, query, params = {}) =>
      this.request({
        path: `/dashboard/materials/${id}/file`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/materials
     * @name AdminMaterialsControllerRemoveVideoFile
     * @request DELETE:/dashboard/materials/{id}/video
     * @secure
     * @response `200` `MaterialEntity`
     */
    adminMaterialsControllerRemoveVideoFile: (id, query, params = {}) =>
      this.request({
        path: `/dashboard/materials/${id}/video`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/skills
     * @name AdminSkillsControllerCreate
     * @request POST:/dashboard/skills
     * @secure
     * @response `200` `SkillEntity`
     */
    adminSkillsControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/skills`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/skills
     * @name AdminSkillsControllerUpdate
     * @request PATCH:/dashboard/skills/{id}
     * @secure
     * @response `200` `SkillEntity`
     */
    adminSkillsControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/skills/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/skills
     * @name AdminSkillsControllerRemove
     * @request DELETE:/dashboard/skills/{id}
     * @secure
     * @response `200` `SkillEntity`
     */
    adminSkillsControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/skills/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/careers
     * @name AdminCareersControllerCreate
     * @request POST:/dashboard/careers
     * @secure
     * @response `200` `CareerEntity`
     */
    adminCareersControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/careers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/careers
     * @name AdminCareersControllerUpdate
     * @request PATCH:/dashboard/careers/{id}
     * @secure
     * @response `200` `CareerEntity`
     */
    adminCareersControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/careers/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/careers
     * @name AdminCareersControllerRemove
     * @request DELETE:/dashboard/careers/{id}
     * @secure
     * @response `200` `CareerEntity`
     */
    adminCareersControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/careers/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-users
     * @name AdminUsersControllerFindMany
     * @request GET:/dashboard/users
     * @secure
     * @response `200` `void`
     */
    adminUsersControllerFindMany: (query, params = {}) =>
      this.request({
        path: `/dashboard/users`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-users
     * @name AdminUsersControllerCreate
     * @request POST:/dashboard/users
     * @secure
     * @response `200` `UserEntity`
     */
    adminUsersControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/users`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-users
     * @name AdminUsersControllerUpdateUser
     * @request PATCH:/dashboard/users/{id}
     * @secure
     * @response `200` `UserEntity`
     */
    adminUsersControllerUpdateUser: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/users/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-users
     * @name AdminUsersControllerDeleteUserProfile
     * @request DELETE:/dashboard/users/{id}
     * @secure
     * @response `200` `UserEntity`
     */
    adminUsersControllerDeleteUserProfile: (id, params = {}) =>
      this.request({
        path: `/dashboard/users/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags admin-users
     * @name AdminUsersControllerUpdateUserProfile
     * @request PUT:/dashboard/users/{id}/profile
     * @secure
     * @response `200` `UserEntity`
     */
    adminUsersControllerUpdateUserProfile: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/users/${id}/profile`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/academies
     * @name AdminAcademiesControllerCreate
     * @request POST:/dashboard/academies
     * @secure
     * @response `201` `void`
     */
    adminAcademiesControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/academies`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/academies
     * @name AdminAcademiesControllerFindAll
     * @request GET:/dashboard/academies
     * @secure
     * @response `200` `void`
     */
    adminAcademiesControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/dashboard/academies`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/academies
     * @name AdminAcademiesControllerUpdateFile
     * @request PATCH:/dashboard/academies/{id}/file
     * @secure
     * @response `200` `void`
     */
    adminAcademiesControllerUpdateFile: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/academies/${id}/file`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/academies
     * @name AdminAcademiesControllerDeleteFile
     * @request DELETE:/dashboard/academies/{id}/file
     * @secure
     * @response `200` `void`
     */
    adminAcademiesControllerDeleteFile: (id, query, params = {}) =>
      this.request({
        path: `/dashboard/academies/${id}/file`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/academies
     * @name AdminAcademiesControllerUpdateLogo
     * @request PATCH:/dashboard/academies/{id}/logo
     * @secure
     * @response `200` `void`
     */
    adminAcademiesControllerUpdateLogo: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/academies/${id}/logo`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/academies
     * @name AdminAcademiesControllerFindOne
     * @request GET:/dashboard/academies/{id}
     * @secure
     * @response `200` `void`
     */
    adminAcademiesControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/dashboard/academies/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/academies
     * @name AdminAcademiesControllerUpdate
     * @request PUT:/dashboard/academies/{id}
     * @secure
     * @response `200` `void`
     */
    adminAcademiesControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/academies/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/academies
     * @name AdminAcademiesControllerRemove
     * @request DELETE:/dashboard/academies/{id}
     * @secure
     * @response `200` `void`
     */
    adminAcademiesControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/academies/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/partners
     * @name AdminPartnersControllerCreate
     * @request POST:/dashboard/partners
     * @secure
     * @response `201` `void`
     */
    adminPartnersControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/partners`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/partners
     * @name AdminPartnersControllerFindAll
     * @request GET:/dashboard/partners
     * @secure
     * @response `200` `void`
     */
    adminPartnersControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/dashboard/partners`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/partners
     * @name AdminPartnersControllerUpdateLogo
     * @request PATCH:/dashboard/partners/{id}/logo
     * @secure
     * @response `200` `void`
     */
    adminPartnersControllerUpdateLogo: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/partners/${id}/logo`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/partners
     * @name AdminPartnersControllerDeleteLogo
     * @request DELETE:/dashboard/partners/{id}/logo
     * @secure
     * @response `200` `void`
     */
    adminPartnersControllerDeleteLogo: (id, params = {}) =>
      this.request({
        path: `/dashboard/partners/${id}/logo`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/partners
     * @name AdminPartnersControllerFindOne
     * @request GET:/dashboard/partners/{id}
     * @secure
     * @response `200` `void`
     */
    adminPartnersControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/dashboard/partners/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/partners
     * @name AdminPartnersControllerUpdate
     * @request PUT:/dashboard/partners/{id}
     * @secure
     * @response `200` `void`
     */
    adminPartnersControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/partners/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/partners
     * @name AdminPartnersControllerRemove
     * @request DELETE:/dashboard/partners/{id}
     * @secure
     * @response `200` `void`
     */
    adminPartnersControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/partners/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/client-logos
     * @name AdminClientLogosControllerCreate
     * @request POST:/dashboard/client-logos
     * @secure
     * @response `201` `void`
     */
    adminClientLogosControllerCreate: (data, params = {}) =>
      this.request({
        path: `/dashboard/client-logos`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/client-logos
     * @name AdminClientLogosControllerFindAll
     * @request GET:/dashboard/client-logos
     * @secure
     * @response `200` `void`
     */
    adminClientLogosControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/dashboard/client-logos`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/client-logos
     * @name AdminClientLogosControllerUpdateLogo
     * @request PATCH:/dashboard/client-logos/{id}/logo
     * @secure
     * @response `200` `void`
     */
    adminClientLogosControllerUpdateLogo: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/client-logos/${id}/logo`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/client-logos
     * @name AdminClientLogosControllerDeleteLogo
     * @request DELETE:/dashboard/client-logos/{id}/logo
     * @secure
     * @response `200` `void`
     */
    adminClientLogosControllerDeleteLogo: (id, params = {}) =>
      this.request({
        path: `/dashboard/client-logos/${id}/logo`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/client-logos
     * @name AdminClientLogosControllerFindOne
     * @request GET:/dashboard/client-logos/{id}
     * @secure
     * @response `200` `void`
     */
    adminClientLogosControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/dashboard/client-logos/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/client-logos
     * @name AdminClientLogosControllerUpdate
     * @request PUT:/dashboard/client-logos/{id}
     * @secure
     * @response `200` `void`
     */
    adminClientLogosControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/dashboard/client-logos/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
    /**
     * No description
     *
     * @tags dashboard/client-logos
     * @name AdminClientLogosControllerRemove
     * @request DELETE:/dashboard/client-logos/{id}
     * @secure
     * @response `200` `void`
     */
    adminClientLogosControllerRemove: (id, params = {}) =>
      this.request({
        path: `/dashboard/client-logos/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  tags = {
    /**
     * No description
     *
     * @tags Tags
     * @name TagsControllerFindMany
     * @request GET:/tags
     * @response `200` `TagsResponse`
     */
    tagsControllerFindMany: (query, params = {}) =>
      this.request({
        path: `/tags`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  news = {
    /**
     * No description
     *
     * @tags news
     * @name NewsControllerFindAll
     * @request GET:/news
     * @response `200` `NewsResponse`
     */
    newsControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/news`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags news
     * @name NewsControllerFindOne
     * @request GET:/news/{id}
     * @response `200` `NewsEntity`
     */
    newsControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/news/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  cases = {
    /**
     * No description
     *
     * @tags cases
     * @name CasesControllerFindAll
     * @request GET:/cases
     * @response `200` `CasesResponse`
     */
    casesControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/cases`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags cases
     * @name CasesControllerFindOne
     * @request GET:/cases/{id}
     * @response `200` `CaseEntity`
     */
    casesControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/cases/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  materials = {
    /**
     * No description
     *
     * @tags materials
     * @name MaterialsControllerFindAll
     * @request GET:/materials
     * @response `200` `MaterialResponse`
     */
    materialsControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/materials`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags materials
     * @name MaterialsControllerFindOne
     * @request GET:/materials/{id}
     * @response `200` `MaterialEntity`
     */
    materialsControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/materials/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags materials
     * @name MaterialsControllerViews
     * @request PATCH:/materials/{id}/views
     * @response `200` `void`
     */
    materialsControllerViews: (id, params = {}) =>
      this.request({
        path: `/materials/${id}/views`,
        method: "PATCH",
        ...params,
      }),
  };
  skills = {
    /**
     * No description
     *
     * @tags skills
     * @name SkillsControllerFindAll
     * @request GET:/skills
     * @response `200` `SkillsResponse`
     */
    skillsControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/skills`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags skills
     * @name SkillsControllerFindOne
     * @request GET:/skills/{id}
     * @response `200` `SkillEntity`
     */
    skillsControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/skills/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  careers = {
    /**
     * No description
     *
     * @tags careers
     * @name CareersControllerFindAll
     * @request GET:/careers
     * @response `200` `CareersResponse`
     */
    careersControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/careers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags careers
     * @name CareersControllerFindOne
     * @request GET:/careers/{id}
     * @response `200` `CareerEntity`
     */
    careersControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/careers/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  contacts = {
    /**
     * No description
     *
     * @tags contacts
     * @name ContactsControllerCreate
     * @request POST:/contacts
     * @response `200` `ContactEntity`
     */
    contactsControllerCreate: (data, params = {}) =>
      this.request({
        path: `/contacts`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags contacts
     * @name ContactsControllerFindAll
     * @request GET:/contacts
     * @response `200` `ContactsResponse`
     */
    contactsControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/contacts`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags contacts
     * @name ContactsControllerFindOne
     * @request GET:/contacts/{id}
     * @response `200` `ContactEntity`
     */
    contactsControllerFindOne: (id, params = {}) =>
      this.request({
        path: `/contacts/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags contacts
     * @name ContactsControllerUpdate
     * @request PATCH:/contacts/{id}
     * @response `200` `ContactEntity`
     */
    contactsControllerUpdate: (id, data, params = {}) =>
      this.request({
        path: `/contacts/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags contacts
     * @name ContactsControllerRemove
     * @request DELETE:/contacts/{id}
     * @response `200` `ContactEntity`
     */
    contactsControllerRemove: (id, params = {}) =>
      this.request({
        path: `/contacts/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  account = {
    /**
     * No description
     *
     * @tags Account
     * @name AccountControllerPutAccount
     * @request PUT:/account
     * @secure
     * @response `200` `UserEntity`
     */
    accountControllerPutAccount: (data, params = {}) =>
      this.request({
        path: `/account`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Account
     * @name AccountControllerPostAvatar
     * @request POST:/account/avatar
     * @secure
     * @response `200` `UserEntity`
     */
    accountControllerPostAvatar: (data, params = {}) =>
      this.request({
        path: `/account/avatar`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerCreateOwner
     * @request POST:/auth/owner
     * @response `201` `void`
     */
    authControllerCreateOwner: (data, params = {}) =>
      this.request({
        path: `/auth/owner`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerLogin
     * @request POST:/auth/login
     * @response `201` `void`
     */
    authControllerLogin: (data, params = {}) =>
      this.request({
        path: `/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerLogout
     * @request POST:/auth/logout
     * @secure
     * @response `201` `void`
     */
    authControllerLogout: (params = {}) =>
      this.request({
        path: `/auth/logout`,
        method: "POST",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerRefresh
     * @request POST:/auth/refresh
     * @secure
     * @response `201` `void`
     */
    authControllerRefresh: (params = {}) =>
      this.request({
        path: `/auth/refresh`,
        method: "POST",
        secure: true,
        ...params,
      }),
    /**
     * No description
     *
     * @tags auth
     * @name AuthControllerAuthMe
     * @request GET:/auth/me
     * @secure
     * @response `200` `void`
     */
    authControllerAuthMe: (params = {}) =>
      this.request({
        path: `/auth/me`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  emailSms = {
    /**
     * No description
     *
     * @tags email-sms
     * @name EmailSmsControllerSendEmail
     * @request POST:/email-sms/send
     * @response `201` `void`
     */
    emailSmsControllerSendEmail: (data, params = {}) =>
      this.request({
        path: `/email-sms/send`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
    /**
     * No description
     *
     * @tags email-sms
     * @name EmailSmsControllerSendFeedback
     * @request POST:/email-sms/feedback
     * @response `201` `void`
     */
    emailSmsControllerSendFeedback: (data, params = {}) =>
      this.request({
        path: `/email-sms/feedback`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  academies = {
    /**
     * No description
     *
     * @tags Academies
     * @name AcademiesControllerFindAll
     * @request GET:/academies
     * @response `200` `void`
     */
    academiesControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/academies`,
        method: "GET",
        query: query,
        ...params,
      }),
    /**
     * No description
     *
     * @tags Academies
     * @name AcademiesControllerViews
     * @request PATCH:/academies/{id}/views
     * @response `200` `void`
     */
    academiesControllerViews: (id, params = {}) =>
      this.request({
        path: `/academies/${id}/views`,
        method: "PATCH",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Academies
     * @name AcademiesControllerDownloadFile
     * @request GET:/academies/{id}/download
     * @response `200` `void`
     */
    academiesControllerDownloadFile: (id, params = {}) =>
      this.request({
        path: `/academies/${id}/download`,
        method: "GET",
        ...params,
      }),
    /**
     * No description
     *
     * @tags Academies
     * @name AcademiesControllerGatedDownload
     * @request POST:/academies/{id}/gated-download
     * @response `201` `void`
     */
    academiesControllerGatedDownload: (id, data, params = {}) =>
      this.request({
        path: `/academies/${id}/gated-download`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  partners = {
    /**
     * No description
     *
     * @name PartnersControllerFindAll
     * @request GET:/partners
     * @response `200` `void`
     */
    partnersControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/partners`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  clientLogos = {
    /**
     * No description
     *
     * @tags client-logos
     * @name ClientLogosControllerFindAll
     * @request GET:/client-logos
     * @response `200` `void`
     */
    clientLogosControllerFindAll: (query, params = {}) =>
      this.request({
        path: `/client-logos`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
}
